<template>
  <div class="screen">
    <template v-if="!ready">
      <p class="counter-band">Checking your account&hellip;</p>
    </template>

    <template v-else-if="!user">
      <h2>Can't Stop</h2>
      <p class="counter-band">
        Every game at Around Table Round needs an account, and Matt lets new
        accounts in by hand. One sign-in covers all of them — if you have
        played any of the others, you are already in.
      </p>
      <button class="primary" @click="signIn">Sign in with Google</button>
    </template>

    <template v-else-if="status === 'pending'">
      <h2>Almost there</h2>
      <p class="counter-band">
        Signed in as <strong>{{ user.displayName || user.email }}</strong>.
      </p>
      <div class="notice">
        <strong>Waiting for Matt to let you in.</strong>
        He only has to do it once — after that you can play every Around Table
        Round game, not just this one. You will land in here automatically the
        moment he does, with no need to refresh.
      </div>
      <button class="secondary" @click="signOutOfSite">Sign out</button>
    </template>

    <template v-else>
      <h2>No access</h2>
      <div class="notice notice--bad">
        This account has not been given access to Around Table Round.
      </div>
      <button class="secondary" @click="signOutOfSite">Sign out</button>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

// The whole-app gate. `siteUsers/{uid}` in the shared Firebase project is the
// source of truth, and one approval covers every game on the hub.
//
// This used to gate ONLINE PLAY ONLY, with solo-against-the-bots wide open to
// anybody, signed out, forever. Matt, 2026-08-30: "pretty much everything
// there other than blockout really needs to be behind the same permissions
// barrier ... where they have to ask my permission to get access." So it now
// sits in front of the entire app, exactly as Thunderstone's and Space Base's
// always have - and there is consequently no "Back" and no play-offline
// escape hatch, because there is nothing behind this screen to go back to.
//
// `ready` is not decoration. `authReady` flips as soon as Firebase Auth
// answers, but the siteUsers watcher's first callback can land a tick later,
// and gating on approval alone would show an already-approved player the
// "waiting for approval" screen for that tick, every launch.
export default {
  name: 'SiteGate',
  computed: {
    ...mapState(['user', 'siteUser', 'authReady', 'siteUserReady']),
    ready() { return this.authReady && this.siteUserReady; },
    status() { return this.siteUser?.status || 'pending'; },
  },
  methods: {
    signIn() { this.$store.dispatch('signIn'); },
    signOutOfSite() { this.$store.dispatch('signOutOfSite'); },
  },
};
</script>
